<template>
   <div class="single-games-tabs">
       <div class="single-games-tab-item" :class="(!selectedOutrightId) ? 'is-selected' : ''" v-if="smallDesktop" v-on:click="selectOutright({
            outrightId: null,
            eventType: 'outrights',
            push: true
            })">
          <div class="signle-game-middle-tab">
              <p>{{ filterSelected || $t('ALL OUTRIGHTS') }}</p>
          </div>
      </div>
        <template v-for="outrightId in selectedOutrightIds">
            <div :key="outrightId"
            class="single-games-tab-item"
            :class="outrightId === selectedOutrightId ? 'is-selected': ''"
            @click="selectOutright({
                                outrightId: outrightId,
                                eventType: 'outrights',
                                push: false
                                })"
            v-if="smallDesktop || selectedOutrightIds.includes(outrightId)">
                <div class="signle-game-left-tab"></div>
                <div class="signle-game-middle-tab">
                    <p>{{outrightName(outrightId)}}</p>
                    <i class="iconset icon-close" @click.stop="removeSelectedOutright(outrightId)"></i>
                </div>
                <div class="signle-game-right-tab"></div>
                </div>
        </template>
    </div>
</template>

<script>

import {
    mapActions,
    mapGetters,
} from 'vuex';

export default {
    name: 'OutrightsTabs',
    props: [
        'filterSelected',
    ],
    methods:
    {
        ...mapActions({
            selectOutright: 'selectOutright',
            removeSelectedOutright: 'removeSelectedOutright',
        }),
        outrightName(outrightId)
        {
            const me = this;
            let outrightName;

            // eslint-disable-next-line guard-for-in
            for (const id in me.getOutrights)
            {
                const outright = me.getOutrights[id];
                if (outright.outrightsOfferId === outrightId)
                {
                    outrightName = outright.name;
                    break;
                }
            }

            return outrightName;
        },
    },
    computed:
    {
        ...mapGetters([
            'isMobile',
            'smallDesktop',
            'getOutrights',
            'selectedOutrightId',
            'selectedOutrightIds',
        ]),
    },
};
</script>
